import Button from 'components/form/Button';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { icons } from 'utils/constants';
import { getDataFromLocalStorage } from 'utils/helpers';
import Card from 'components/Layout/Card';
import ProfileCompletion from '../Dashboard/ProfileCompletion';

const ProfileInfo = () => {
  const navigate = useNavigate();
  const [researchProfileCount, setResearchProfileCount] = useState(50);
  let { completion_details } = getDataFromLocalStorage();
  useEffect(() => {
    setResearchProfileCount(completion_details);
  }, []);

  return (
    <Card>
      {/* Top Title Bar */}
      <div className="d-flex align-items-center border-bottom cp-16">
        <button
          className="btn btn-link text-decoration-none p-0 me-3"
          onClick={() => navigate(-1)}
        >
          <img
            src={icons.leftArrow}
            alt="Back"
            className="me-2"
            style={{ height: '20px' }}
          />
        </button>
        <h6 className="text-16-400-20">Update Profile Information</h6>
      </div>

      <div
        style={{ minHeight: '65vh' }}
        className="cp-20 d-flex flex-column justify-content-center"
      >
        {/* Centered Content */}
        <div className="text-center">
          <h5 className="text-24-500-30 cmt-47 cmb-31">
            Profile Information Required
          </h5>
          <p className="text-muted text-16-400-28 color-black-olive cmb-15">
            Your profile is currently <strong>{researchProfileCount}%</strong>{' '}
            complete.
            <br />
            Please update the remaining details to unlock full access and
            continue.
            <br />
            Click "Update Profile" to complete the pending sections.
          </p>
        </div>

        {/* Centered profile section container */}
        <div className="mx-auto" style={{ maxWidth: '500px', width: '100%' }}>
          <ProfileCompletion
            researchProfileCount={researchProfileCount}
            isShowButton
          />
        </div>
      </div>
    </Card>
  );
};

export default ProfileInfo;
